import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-admin-preview',
  imports: [
    NgIf
  ],
  templateUrl: './admin-preview.component.html',
  styleUrl: './admin-preview.component.scss'
})
export class AdminPreviewComponent {


  @Input() adminDisplay: boolean = false;
  @Input() uncorrectedUrl: boolean = false;
  @Input() displayPageFalse: boolean = false;
}
